import React from 'react';
import Post from '../components/feedCards/userPost';
import { useStoreState } from 'easy-peasy';
import { Paper, Box } from '@material-ui/core';
import CommunityListItem from './community/communityListItem';
import Promocard from './feedCards/promocard';
import Carousel from './carousel';
import UserCard from './feedCards/userCard';

const FeedCard = ({ postId }) => {
  const post = useStoreState((state) => state.posts.postsObj[postId]);

  function componentMap() {
    switch (post?.subType) {
      case 'I':
        return <Promocard post={post} />;
      case 'PL':
        return <Post post={post} postId={postId} />;
      case 'H':
        return;
      case 'W':
        return <Carousel postId={postId} post={post} />;
      case 'U':
        return <UserCard usersObj={post} />;
      case 'C':
        return (
          <Box px={4}>
            <CommunityListItem isShowDescription={true} post={post} />
          </Box>
        );

      default:
        return <Post post={post} />;
    }
  }
  return <Paper square={true}>{componentMap(post.subType)}</Paper>;
};

export default FeedCard;
